import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { UserDetailsContext } from "../../HardwareDetails/HardwareDetails";
import { ActionsModal } from "../ActionsModal";
import { generateHardwareIssueTicket } from "../../../helper/generateTicket";
import { createZendeskTicket } from "../../../resource/bff";
import { ActionStatusContext } from "../Actions";

export default function HardwareIssuesModal(props) {
  const userDetails = useContext(UserDetailsContext);
  const { setIsLoading, showActionResponse, setIsActionSuccess } =
    useContext(ActionStatusContext);
  const [serialNumber, setSerialNumber] = useState("");
  const [repairType, setRepairType] = useState("");
  const [issue, setIssue] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    props.onClose();
    setIsLoading(true);
    const assetName = props.assets.find(
      (asset) => asset.serialNumber == serialNumber
    ).modelName;

    const ticket = generateHardwareIssueTicket(
      userDetails.workingOffice.country,
      userDetails.homeOffice.name,
      userDetails.homeOffice.country,
      userDetails.employeeNumber,
      assetName,
      serialNumber,
      repairType,
      issue
    );
    try {
      await createZendeskTicket(ticket);
      setIsActionSuccess(true);
    } catch (error: any) {
      setIsActionSuccess(false);
    } finally {
      setSerialNumber("");
      setIssue("");
      setRepairType("");
    }
    setIsLoading(false);
    showActionResponse();
  };

  return (
    <ActionsModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      heading={"Report"}
      title={"Hardware Issues"}
      isFormValid={issue != "" && serialNumber != ""}
      onSubmit={onSubmit}
    >
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "25px" }}
      >
        <InputLabel id={"device-dropdown-label"}>
          <Typography display={"inline"}>Select assigned device</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        {props.assets && (
          <Select
            labelId={"device-dropdown-label"}
            onChange={(e: SelectChangeEvent) => {
              setSerialNumber(e.target.value);
            }}
            value={serialNumber}
            sx={{
              width: "400px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {props.assets.map((row) => (
              <MenuItem key={row.serialNumber} value={row.serialNumber}>
                <span
                  style={{
                    width: "368px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >{`${row.modelName} - ${row.serialNumber}`}</span>
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "25px" }}
      >
        <InputLabel id={"repair-dropdown-label"}>
          <Typography display={"inline"}>Select repair type</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        {props.assets && (
          <Select
            labelId={"repair-dropdown-label"}
            onChange={(e: SelectChangeEvent) => {
              setRepairType(e.target.value);
            }}
            value={repairType}
            sx={{
              width: "400px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {props.assets[0].repairTypes.map((type) => (
              <MenuItem key={type} value={type}>
                <span
                  style={{
                    width: "368px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {type}
                </span>
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "32px" }}
      >
        <InputLabel id={"reason-label"}>
          <Typography display={"inline"}>Please specify the issue</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        <Input
          multiline
          maxRows={5}
          value={issue}
          onChange={(event) => {
            setIssue(event.target.value);
          }}
          aria-labelledby={"reason-label"}
        />
      </FormControl>
    </ActionsModal>
  );
}
